import { getDocuments } from './actions';

export const reducer = (state = { data: [], isFetching: false, hasError: false, error: null }, action) => {
  switch (action.type) {
    case getDocuments.pending.type:
      return {
        ...state,
        isFetching: true,
        hasError: false,
        error: null
      };
    case getDocuments.fulfilled.type:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case getDocuments.rejected.type:
      return {
        ...state,
        isFetching: false,
        hasError: true,
        error: action.error
      };
    default:
      return state;
  }
};
